import React, { createContext, useCallback, useContext, useState, ReactNode } from "react";
import LoadingComponent from "../components/loading/Loading";

interface LoaderContextType {
  isLoading: boolean;
  showLoader: (value: boolean) => void;
}

const LoaderContext = createContext<LoaderContextType | undefined>(undefined);

export const useLoader = () => {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoader must be used within a LoaderProvider");
  }
  return context;
};

interface LoaderProviderProps {
  children: ReactNode;
}

export const LoaderProvider: React.FC<LoaderProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showLoader = useCallback((value: boolean) => {
    setIsLoading(value);
  }, []);

  return (
    <LoaderContext.Provider value={{ isLoading, showLoader }}>
      {children}
      {isLoading && <LoadingComponent />}
    </LoaderContext.Provider>
  );
};
